<template>
    <div>
        <div class="simple-form flex col-4 label" v-if="flag">
            <div class="form-group center">
                <div class="form-label">
                    <label>供应商名称</label>
                </div>
                <div class="form-value">
                    <span>{{contranct.sndPartyName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>系统合同编号</label>
                </div>
                <div class="form-value">
                    <span>{{contranct.fstPartyHtBh}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合同状态</label>
                </div>
                <div class="form-value">
                    <span v-if="contranct.confirmed" class="">履约中</span>
                    <span v-if="contranct.fullfilled" class="">履约完成</span>
                    <span v-if="contranct.checked" class="">已验收</span>
                </div>
            </div>
        </div>
        <swb-servc-order-search name="servcOrderSearch" :no="no" :isContract="false" @showServcOrderSearch="servcOrderSearch"></swb-servc-order-search>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="handlePageChange" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>

    </div>
</template>

<script>
    import { Utils, $  } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { showPayVoucherListForSelectDlg } from '../payment/ActRecDlg'

    import contractApi from '../../api/contract'
    import servcOrderApi from '../../api/servcOrder'

    import SwbServcOrderOperate from './ServcOrderOperate';

    Routes.add(SwbServcOrderOperate);

    import SwbAfterSaleOrderCreate from './AfterSaleOrderCreate';

    Routes.add(SwbAfterSaleOrderCreate);

    import SwbComplaintSave from '../custsvc/ComplaintSave';

    Routes.add(SwbComplaintSave);

    import SwbAfterSaleOrderList from './AfterSaleOrderList';

    Routes.add(SwbAfterSaleOrderList);

    import SwbPayVoucherList from '../payment/PayVoucherList';

    Routes.add(SwbPayVoucherList);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';

    Routes.add(SwbTradeVoucherList);

    import SwbServcOrderSearch from './ServcOrderSearch'
    import {showRouteLayer} from "../ctrl/RouteLayer";
    Vue.regist(SwbServcOrderSearch);
    export default {
        name: 'swb-servc-order-list',
        path: '/servc/order/list',
        avlActions: 'view_pay_detail|view_detail|initiate_complaint|view_after_sale_order|cancel',
        avlActionNames: '付款明细、订单详情、发起投述',
        avlScopes: 'retailer',
        desc: '服务订单列表',
        helpArticleCode: 'retailer-servc-order-list',
        data: function () {
            return {
                confKey: 'swb-servc-order-list',
                //
                theTableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 260,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                servOrderList: [],
                contractId: null,
                contranct: {},
                servcOrderStateList: [],
                afterSaleSrcOrderNo: null,
                workAssignStateX: [],
                servcOrderState: null,
                no: null,
                searchDate: '',
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                flag: false,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                path: null
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        created: function () {
            this.path = Vue.$getClassInfo(this).path;
            // --------------------查询--------------------------------
            this.fetchData();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.simple-form, [name="servcOrderSearch"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{

                    'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.tradeNo != null) {
                            return '<span><a class="table-cell-link" >' + row.tradeNo + '</a></span>';
                        }
                    },
                    'trackPhaseName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.trackPhaseName != null) {
                            return '<span>' + row.trackPhaseName + '</span>';
                        }
                    },

                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.state != null) {
                            return '<span>' + row.state + '</span>';
                        }
                    },
                    'servicerShopName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servicerShopFlag == true) {
                            return '<span>' + row.servicerShopName + '</span>';
                        } else {
                            return '<span>' + self.workAssignStateX[row.workAssignStateX] + '</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, colConf) {
                        let btnList = [];
                        if(self.checkActionPerm('view_pay_detail') && contractId == null) {
                            btnList.push({
                                name: 'view_pay_detail',
                                text: '付款明细'
                            })
                        }
                        if(self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '订单详情'
                            })
                        }
                        if(checkActionPerm('cancel') && row.cancellable && !row.cancelled) {
                            btnList.push({
                                name: 'cancel',
                                text: '取消'
                            })
                        }
                        if(self.checkActionPerm('initiate_complaint')) {
                            btnList.push({
                                name: 'initiate_complaint',
                                text: '发起投诉'
                            })
                        }
                        if(self.checkActionPerm('view_after_sale_order') && row.hasAfterSafes) {
                            btnList.push({
                                name: 'view_after_sale_order',
                                text: '查看售后订单'
                            })
                        }
                        // if(self.checkActionPerm('pre_pay') && !row.invalid && row.contractId == null) {
                        //     btnList.push({
                        //         name: 'pre_pay',
                        //         text: '预付'
                        //     })
                        // }
                        return btnList
                    }
                }, /* 单元格按钮点击处理函数 */ {
                    'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.toTradeVoucherList(row.tradeNo)
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, event) {
                        if(btnName == 'view_pay_detail') { // 付款明细
                            self.resetpay(row)
                        } else if(btnName == 'view_detail') { // 订单详情
                            self.searchOrder(row.id)
                        } else if(btnName == 'cancel') { // 取消
                            self.doCancalServcOrder(row.id)
                        } else if(btnName == 'initiate_complaint') { // 发起投诉
                            self.complaintSave(row.id)
                        } else if(btnName == 'view_after_sale_order') { // 查看售后订单
                            self.searchAfterSale(row.no)
                        }else if(btnName == 'pre_pay') { // 预付
                            self.doPayPre(row)
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },

            fetchData: function () {
                //----------------------分页--------------------------------
                //保持pageSize的一致性
                this.pageSize = this.pageSizes.first();
                //----------------------搜索排序----------------------------
                let no = this.$route.query.no || null;
                if(!Utils.isNoB(no)) {
                    this.no = no;
                    this.queryModel.filterItems.no = no;
                }
                //----------------------查询------------------------------s

                this.contractId = this.$route.query.contractId || null;
                this.servcOrderStateList = getEnumList("servcOrderState");
                this.workAssignStateX = getEnumMap("workAssignStateX", "value2text");
                if(this.contractId != null) {
                    this.getContractById(this.contractId);
                    this.flag = true;
                }
                this.getServOrderList();
            },
            servcOrderSearch: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getServOrderList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getContractById: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        self.contranct = result.data;
                    }
                });
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                let self = this;
                this.pageNumber = val;
                this.getServOrderList();
            },

            getServOrderList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.contractFlag = false;
                if(!Utils.isNoB(self.contractId)) {
                    filterItems.contractId = self.contractId;
                    filterItems.contractFlag = true;
                }
                if(!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                if(self.servcOrderState == 2) {
                    filterItems.servicerShopFlag = false;
                }
                if(!Utils.isNoB(self.afterSaleSrcOrderNo)) {
                    filterItems.afterSaleSrcOrderNo = self.afterSaleSrcOrderNo;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                servcOrderApi.getServOrderList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let servOrderList = result.data.rows;
                        //
                        self.servOrderList = servOrderList;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;

                        //
                        self.renderTable(servOrderList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 预付功能
            doPayPre(row){
                let self = this;
                let params = {
                    title: '订单金额 - 预付',
                    doPrePay: true,
                    showBtn: true,
                    payPreFilter: {
                        orderType: getEnumInfoWith("orderType", "name", "ServcOrder").value,
                        orderId: row.id,
                        orderNo: row.no,
                        sellerRealComId: row.sellerRealComId,
                        buyerRealComId: row.buyerRealComId,
                        amount: row.amount
                    },
                    filter: {
                        orderType: getEnumInfoWith("orderType", "name", "ServcOrder").value,
                        orderId: row.id
                    },
                    parentSelf: self,
                    parentPath: self.path
                };
                showPayVoucherListForSelectDlg(params, function (refresh) {
                    //
                    if(Utils.isTrue(refresh)) {
                        self.getServOrderList();
                    }
                });
            },
            selectionMenu: function (value) {
                let self = this;
                let servcOrderStateList = self.servcOrderStateList;
                for(let i = 0; i < servcOrderStateList.length; i++) {
                    let servcOrderState = servcOrderStateList[i];
                    if(servcOrderState.value == value) {
                        self.servcOrderState = value;
                        self.getServOrderList();
                    }
                }

            },
            searchOrder: function (orderId) {
                this.$router.push({
                    path: SwbServcOrderOperate.path,
                    query: {
                        id: orderId,
                    }
                });
            },
            toTradeVoucherList: function (tradeNo) {
                let self = this;
                let tradeType = 1;
                self.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {
                        no: tradeNo,
                        tradeVoucherType: tradeType
                    }
                })
            },
            searchAfterSale: function (no) {
                this.$router.push({
                    path: SwbAfterSaleOrderList.path,
                    query: {no: no}
                })
            },
            parseFloat: function (price) {
                if(isNoB(price)) {
                    price = 0.00;
                }
                return Utils.parseFloat(price);
            },
            // 发起投诉
            complaintSave: function (orderId) {
                let subjectType = getEnumInfoWith("complaintSubjectType", "name", "ServcOrder");
                //
                this.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        orderId: orderId,
                        subjectType: subjectType.value,
                    }
                })
            },
            resetpay: function (row) {
                let srcVoucherType = getEnumInfoWith("srcVoucherType", "name", "Order").value;
                let query = {srcVoucherType: srcVoucherType, srcVoucherId: row.id, srcVoucherInnerNo: row.no};
                showRouteLayer({
                    title: '付款明细',
                    query: query,
                    template: SwbPayVoucherList
                });
            },
            doCancalServcOrder: function (orderId) {
                let self = this;
                self.$prompt('请输入取消原因', '取消确认对话框', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    let cancelCause = data.value;
                    //
                    let postData = {};
                    postData.orderId = orderId;
                    postData.cancelCause = cancelCause;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    servcOrderApi.doCancelGoodsOrder(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type == "info") {
                            MsgBox.info("操作成功");
                            self.getServOrderList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderList.vue